<div class="central-location-view">
  <div class="cc-action-panel">
    <div class="central-view-filters row">
      <div class="col-md-6">
        <app-location-multi-selector  [isLobby]="true" labelText="{{'_General_Location_Text_' | translate }}" selectedLocationName="{{'_General_No_Branches_Text_' | translate }}"
          [selectorDisabled]="selectorDisable" (onLocationsData)="handleDefaultSelection($event)"
          (onChange)="handleLocationData($event)" [checkedKeys]="checkedKeys" 
          [dispatchStateEvent]="false" [hideBranchLess]="true" [isIncludeFloatLocation]="false"></app-location-multi-selector>
      </div>
    </div>
  </div>

  <div class="grid-view central-views-grid-wrapper"> 
    <kendo-grid [data]="gridView" [pageSize]="pageSize" [skip]="skip" [pageable]="true" [sortable]="{ allowUnsort: false, mode: 'single' }" [sort]="sort" [scrollable]="'scrollable'"
      (pageChange)="pageChange($event)" (sortChange)="sortChange($event)">
      <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>
      <kendo-grid-column field="location.locationName" title="{{'_General_Location_Text_' | translate }}" [width]="200" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="currentWaitTime" title="{{'_Lobby_Current_Wait_Time_Text_' | translate }}	" [width]="200" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold' }">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.currentWaitTime * 1000 | date: "HH:mm:ss":"UTC" }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="visitorsWaiting" title="{{'_Lobby_Waiting_In_Lobby_Text_' | translate }}" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="visitorServed" title="{{'_Lobby_Total_Assists_Text_' | translate }}" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="serviceProvided" title="{{'_Lobby_Total_PS_Provided_Text_' | translate }}" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="avgAssistTime" title="{{'_General_Average_Assist_Time_Text_' | translate }}" [sortable]="true" [format]=""
        [headerStyle]="{ 'font-weight': 'bold'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.avgAssistTime * 1000 | date: "HH:mm:ss":"UTC" }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="avgWaitTime" title="{{'_General_Average_Wait_Time_Text_' | translate }}" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.avgWaitTime * 1000 | date: "HH:mm:ss":"UTC" }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="abandoned" title="{{'_Lobby_Total_Abandons_Text_' | translate }}" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>
